export default {
  InspectFaucet: "faucet-inspector",
  CreateFaucet: "faucet-creator",
  CloseFaucet: "faucet-closer",
  TokenAirdrop: "token-airdrop"
};
